import { ThermographicInspectionRecordType } from "pages/thermography/model/enumerations/thermographic-inspection-record-type.model";
import { IEquipment } from "pages/thermography/model/equipment.model";
import { IThermogram } from "pages/thermography/model/thermogram.model";
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { ConditionType } from "pages/thermography/model/enumerations/condition-type.model";
import { IPlant } from "pages/thermography/model/plant.model";
import { IEquipmentComponent } from "pages/thermography/model/equipment-component.model";
import { IUserInfo } from "pages/thermography/model/user-info.model";
import { IInspectionRecord } from "pages/thermography/model/inspection-record.model";

export interface AnomalyRecord {
    id: string;
    name?: string;
    type?: keyof typeof ThermographicInspectionRecordType;
    serviceOrder?: string | null;
    createdAt?: dayjs.Dayjs;
    analysisDescription?: string | undefined;
    condition?: keyof typeof ConditionType;
    deltaT?: number;
    periodicity?: number | null;
    deadlineExecution?: dayjs.Dayjs | null;
    nextMonitoring?: dayjs.Dayjs | null;
    recommendations?: string | null;
    finished?: boolean | null;
    finishedAt?: dayjs.Dayjs | null;
    plant?: IPlant;
    route?: IInspectionRecord | null;
    equipment?: IEquipment | null;
    component?: IEquipmentComponent | null;
    createdBy?: IUserInfo;
    finishedBy?: IUserInfo;
    thermogram: IThermogram | null;
    thermogramRef: IThermogram | null;
}

export const anomalyRecordDefaultValue: Readonly<AnomalyRecord> = {
    id: uuidv4(),
    name: '',
    equipment: null,
    type: ThermographicInspectionRecordType.NO_ANOMALY,
    plant: { 'id': '', 'name': '', 'code': '' },
    createdAt: dayjs(),
    deadlineExecution: null,
    nextMonitoring: null,
    condition: ConditionType.NORMAL,
    deltaT: undefined,
    periodicity: -1,
    serviceOrder: '',
    analysisDescription: '',
    recommendations: '',
    finished: false,
    component: null,
    thermogram: null,
    thermogramRef: null
};
